import React, { useState, useEffect, useRef } from 'react';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { getJwt, postJwt, deleteJwt } from '../../helpers/clearnet_api_helper';
import CSDateInput from '../../components/Common/CSDateInput';
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
//import { MsgType, showOkModal, showYesNoModal } from '../../components/Common/ModalManager';
//import Autocomplete from 'react-autocomplete';
import { Link, useNavigate, useLocation } from 'react-router-dom';
//import { MsgType, showOkModal, showYesNoModal } from '../../components/Common/ModalManager';
import '../../assets/clearstone/cs-flexheaderbar.css';
import { userStatus } from './CSHHelper';
import CSCheckbox from "../../components/Common/CSCheckbox";
import { getUserInfo } from './CSHHelper';
import { useCSHMessage } from "./useCSHMessage";
import { useCSHDialog } from "./useCSHDialog";



const API_URL = process.env.REACT_APP_API_URL;

const inputStyle = {
    height: '38px', // Set consistent height
    padding: '6px 12px', // Adjust padding for better alignment
    fontSize: '14px', // Ensure consistent font size
    lineHeight: '1.5',
    border: '1px solid #ced4da',
    borderRadius: '4px',
    boxSizing: 'border-box', // Ensure padding doesn't affect height
    //width: '300px', // Optional: Set consistent width
};

const Users = () => {

    const [criteria, setCriteria] = useState({}); // Fix: initialize as object
    const { control, trigger, formState: { errors } } = useForm(); // Initialize form control
    const [Users, setUsers] = useState([]);
    const [isFilterCollapsed, setIsFilterCollapsed] = useState(true); // State to manage Filter collapse
    const [suggestions, setSuggestions] = useState([]); // State to store autocomplete suggestions
    const [skipCount, setSkipCount] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMoreRecords, setHasMoreRecords] = useState(true); // Track if more records are available
    const observerRef = useRef(null); // Ref for the intersection observer - used for infinite scrolling
    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');
    const [roles, setInstances] = useState([{ value: '', text: '--Please select an role--' }]);
    const [isCriteriaChanged, setIsCriteriaChanged] = useState(false);
    const [isWorking, setIsWorking] = useState(null);
    const [showMessage, message] = useCSHMessage();
    const [showDialog, dialog] = useCSHDialog();

    const { userEmail, userRole } = getUserInfo();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {

        const params = new URLSearchParams(location.search);
        const search = params.get('search') || '';
        const role = params.get('role') || '';
        const showInactive = params.get('showInactive') === 'true';

        setCriteria(prev => ({
            ...prev,
            search,
            role
        }));

        // Fetch initial data here
        fetchUsers({ search, role, showInactive }, 0);

        getJwt(`api/ClearStoneHub/Roles/roleslist`).then(response => {
            setInstances([{ value: '', text: '--Please select a role--' }, ...response]);
        });

    }, []);


    // force auto-submit on certain criteria changes
    useEffect(() => {
        if (isCriteriaChanged) {
            handleSubmit(); // Call handleSubmit after criteria is updated            
        }
    }, [criteria.showInactive]); // Run this effect whenever criteria is changed or cleared



    const handleCreate = () => {
        navigate('/ClearStoneHub/Users/0');
    };

    const handleEdit = (id) => {
        navigate(`/ClearStoneHub/Users/${id}`);
    };

    const handleRemove = async (id, userEmail) => {
        // e.preventDefault();

        try {

            const confirm = await showDialog({
                title: (
                    <>
                        Do you want to remove <strong>{userEmail}</strong>?
                    </>
                ),
                confirmText: "Yes",
                cancelText: "No",
                mode: "confirmation"
            });

            if (confirm) {

                setIsWorking(true);
                await removeUser(id);
                setIsWorking(null);
            }

        } catch (error) {
            setIsWorking(null);
            await showMessage({ message: "Error removing user: " + (error?.message || 'Unknown error'), messageType: "danger" });
        }
    };

    const removeUser = async (id) => {

        try {

            const response = await deleteJwt(`api/ClearStoneHub/Users/${id}`, { adminEmail: userEmail }); // pass id as param

            // After deletion, refresh the list
            setUsers((prevUsers) => {
                return prevUsers.filter(user => user.id !== id);
            });

        } catch (error) {
            console.error('Error deleting User:', error);
        }
    };


    // const handleRemove = async (id, userEmail) => {

    //     const confirm = await showDialog({
    //         title: (
    //             <>
    //                 Are you sure you want to remove <strong>{userEmail}</strong>?
    //             </>
    //         ),
    //         confirmText: "Yes",
    //         cancelText: "No",
    //         mode: "confirmation"
    //     });

    //     if (confirm) {

    //         try {

    //             setIsWorkingOnItem(true);
    //             await removeUser(id);
    //             setIsWorkingOnItem(null);

    //         } catch (error) {
    //             setIsWorkingOnItem(null);
    //             await showMessage({ message: "Error removing user: " + (error?.message || 'Unknown error'), messageType: "danger" });
    //         }
    //     }

    // }


    // async function removeUser(id, isFolder) {

    //   const response = await deleteJwt(`api/ClearStoneHub/Users/${id}`, { adminEmail: userEmail });

    //   // refresh the items list after creation     
    //   await refreshComponent(parentId);


    //   setError(null);

    //   return response;

    // }

    const fetchUsers = async (crit = criteria, skip = skipCount) => {

        if (!hasMoreRecords) return; // Stop fetching if no more records are available

        setIsLoading(true);

        try {
            const response = await getJwt('api/ClearStoneHub/Users', {
                skipCount: skip,
                pageSize,
                search: crit.search,
                roleId: crit.role,
                showInactive: crit.showInactive,
                sort: getSortValue()
            });

            console.log(`Number of records fetched: ${response.length}`); // Log the number of records

            if (response.length < pageSize) {
                setHasMoreRecords(false); // No more records available
            }

            if (response.length > 0) {
                setUsers((prevUsers) => {
                    // Filter out duplicates based on RouteId - normally we should not be getting dups but this is a safety check
                    const newUsers = response.filter(
                        (newUser) =>
                            !prevUsers.some(
                                (existingRoute) => existingRoute.id === newUser.id
                            )
                    );
                    return [...prevUsers, ...newUsers]; // Append only new Users
                });

                setSkipCount((prevSkipCount) => prevSkipCount + pageSize); // Increment skipCount
            }

        } catch (error) {
            setHasMoreRecords(false); // No more records available - to prevent infinte reloading/scrolling
            console.error('Error fetching Users:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Infinite scroll observer
    useEffect(() => {
        if (!hasMoreRecords) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !isLoading) {
                    // Always use latest skipCount and criteria
                    fetchUsers(criteria, skipCount);
                }
            },
            { rootMargin: '100px' }
        );

        const currentRef = observerRef.current;
        if (currentRef) observer.observe(currentRef);

        return () => {
            if (currentRef) observer.unobserve(currentRef);
            observer.disconnect();
        };
    }, [isLoading, hasMoreRecords, criteria, skipCount]);


    useEffect(() => {
        setUsers([]);
        setSkipCount(0);
        setHasMoreRecords(true);
        fetchUsers(criteria, 0);
    }, [sortField, sortDirection]);


    const handleRoleChange = (e) => {
        const value = e.target.value;
        setCriteria(prev => ({ ...prev, role: value }));
        setIsCriteriaChanged(true); // Mark criteria as changed
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setCriteria({ ...criteria, [name]: checked });
        setIsCriteriaChanged(true); // Mark criteria as changed        
    };



    const handleSubmit = async (e, crit = criteria) => {
        if (e) e.preventDefault(); // prevent form reloading on sumbit

        const isValidForm = await trigger();

        if (isValidForm === true) {

            // clear Users data and get ready to load new results
            setUsers([]);
            setSkipCount(0); // reset skipCount to bring new results from row 0 since criteria has been changed
            setHasMoreRecords(true); //reset hasMoreRecords since criteria has been changed

            // Update URL with filters
            updateUrlWithFilters(crit.search, crit.role, crit.showInactive);

            fetchUsers(crit, 0);

            setIsCriteriaChanged(false);

            console.log('Criteria:', JSON.stringify(criteria, null, 2));
        }
    };

    const handleClear = async (e) => {

        // clear criteria - ensure role is reset to empty string so the select shows the default
        const cleanCriteria = { role: '' };
        setCriteria(cleanCriteria);

        // clear suggestions as well (optional)
        setSuggestions([]);

        handleSubmit(null, cleanCriteria);
    };



    const handleSearchChange = (value) => {
        setCriteria((prev) => ({ ...prev, search: value })); // Update the search field in criteria
        setIsCriteriaChanged(true); // Mark criteria as changed

        if (value.length >= 3) {
            fetchSuggestions(value); // Fetch suggestions if input length is 3 or more
        } else {
            setSuggestions([]); // Clear suggestions if input length is less than 3
        }
    };

    const fetchSuggestions = async (prefix) => {
        try {
            const response = await getJwt('api/Shared/GetSearchAutoComplete', { prefix }); // Replace with your API endpoint
            setSuggestions(response); // Update suggestions state with the response
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        }
    };

    const handleSuggestionSelect = (value) => {
        setCriteria((prev) => ({ ...prev, search: value })); // Update the search field in criteria
        setIsCriteriaChanged(true); // Mark criteria as changed

        setSuggestions([]); // Clear suggestions after selection
    };


    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
        setSkipCount(0);
        setUsers([]);
        setHasMoreRecords(true);
        // Do NOT call fetchUsers here!
    };

    const getSortValue = () => {
        return sortDirection === 'desc' ? `${sortField}_desc` : sortField;
    };

    // this does not cause page reload, just pushes filter params to the url
    const updateUrlWithFilters = (search, role, showInactive) => {
        const params = new URLSearchParams();
        if (search) params.set('search', search);
        if (role) params.set('role', role);
        if (showInactive !== undefined) params.set('showInactive', showInactive);
        navigate(`? ${params.toString()}`, { replace: true });
    };





    return (
        <div className="page-content" style={{ cursor: isWorking ? 'progress' : undefined }}>
            <div className="container-fluid">
                <Breadcrumbs title="ClearStoneHub Users"
                    items={[
                        { label: <> ClearStoneHub </>, link: "/ClearStoneHub" },
                        { label: <> Users</> }
                    ]}
                />

                <div className="card">
                    <div className="card-body">
                        {/* <h3 className="card-title">MONITORS</h3>
                        <br /> */}

                        {/* Collapsible Filter Section */}
                        <div>
                            <form onSubmit={handleSubmit}>
                                <div
                                    className="flex-header-bar filter"
                                    onClick={() => setIsFilterCollapsed(!isFilterCollapsed)} // Toggle collapse state
                                >
                                    <h3 className="card-title" >Filter</h3>
                                    <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                                        {isFilterCollapsed ? '+' : '-'}
                                    </span>
                                </div>
                                {!isFilterCollapsed && ( // Show content only when not collapsed
                                    <div>
                                        {/* <form onSubmit={handleSubmit}> */}
                                        <br />
                                        <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', gap: '12px' }}>

                                            <div className="form-group mr-3 mb-3" style={{ minWidth: '320px', flex: '0 0 520px' }}>
                                                <label>Search</label>
                                                {/* Inline container: role select + autocomplete on same row */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 160 }}>
                                                        {/* <label style={{ marginBottom: 6 }}>Instance</label> */}
                                                        <select className="form-control" value={criteria.role || ''} onChange={handleRoleChange}>
                                                            {roles.map(inst => (
                                                                <option key={inst.value || inst.text} value={inst.value}>{inst.text}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div style={{ flex: 1, position: 'relative' }}>
                                                        {/* <label style={{ visibility: 'hidden', height: 0 }}>Search input spacer</label> */}
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            style={{ ...inputStyle, width: '100%' }}
                                                            placeholder="Search by name or email"
                                                            value={criteria.search || ''}
                                                            onChange={e => handleSearchChange(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="form-group mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary mt-4"
                                                    onClick={handleSubmit}
                                                >
                                                    Search&nbsp;
                                                </button>
                                            </div>

                                            <div className="form-group mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-default mt-4"
                                                    onClick={handleClear}
                                                    style={{
                                                        border: '1px solid #ced4da', // Add a border
                                                        borderRadius: '4px', // Optional: Add rounded corners
                                                        display: 'flex', // Use flexbox
                                                        alignItems: 'center', // Vertically align icon and text
                                                        gap: '0.5rem', // Add spacing between icon and text
                                                    }}
                                                >
                                                    Clear Filter
                                                </button>
                                            </div>

                                            <div className="form-group mb-3">
                                                <div className="form-check form-switch form-switch-lg"
                                                >
                                                    <CSCheckbox
                                                        name="showInactive"
                                                        checked={!!criteria.showInactive}
                                                        onChange={handleCheckboxChange}
                                                        label="Show Inactive"
                                                    />
                                                    {/* <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id="showHidden"
                                                        name="showHidden"
                                                        checked={criteria.showHidden}
                                                        onChange={handleCheckboxChange} // Link to handleCheckboxChange
                                                    //style={{ width: '1.5rem', height: '1.5rem' }}
                                                    /> */}
                                                    {/* <label className="form-check-label" htmlFor="showHidden">
                                                        Show Hidden
                                                    </label> */}
                                                </div>
                                            </div>



                                        </div>

                                    </div>
                                )}
                            </form>
                        </div>
                        {/* End of Collapsible Filter Section */}

                        <br />

                        {/* Users */}
                        <div
                            className="flex-header-bar"
                        >
                            <h3 className="card-title">Users</h3>
                        </div>

                        {/* Table */}
                        <div style={{ width: '100%' }}>


                            <div className="row">
                                <div className="col-md-12">
                                    <div className="panel panel-default">
                                        <div className="panel-body">
                                            <p>
                                                <button className="btn btn-success" onClick={() => handleCreate()}>
                                                    Add New
                                                </button>
                                            </p>

                                            <div className="table-responsive ls-table">
                                                <table className="table table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                <strong>
                                                                    <button type="button" className="btn btn-link" onClick={() => handleSort('email')}>
                                                                        Email
                                                                    </button>
                                                                </strong>
                                                            </th>
                                                            <th>
                                                                <strong>
                                                                    <button type="button" className="btn btn-link" onClick={() => handleSort('first_name')}>
                                                                        Name
                                                                    </button>
                                                                </strong>
                                                            </th>
                                                            <th>
                                                                <strong>
                                                                    <button type="button" className="btn btn-link" onClick={() => handleSort('last_name')}>
                                                                        Last Name
                                                                    </button>
                                                                </strong>
                                                            </th>
                                                            <th className="text-center">Role</th>
                                                            <th className="text-center">Status </th>
                                                            <th className="text-center" />
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Users && Users.length > 0 ? (
                                                            Users.map((item) => {
                                                                return (
                                                                    <tr key={item.email}>
                                                                        {/* <td>
                                                                            {item.email ? (
                                                                                <Link to={`/ClearStoneHub/Users/Info?id=${item.id}`}>{String(item.email).toUpperCase()}</Link>
                                                                            ) : (
                                                                                <span />
                                                                            )}
                                                                        </td> */}
                                                                        <td>{item.email}</td>
                                                                        <td>{item.firstName}</td>
                                                                        <td>{item.lastName}</td>
                                                                        <td className="text-center">{item.roleName}</td>
                                                                        <td className="text-center">{userStatus[item.status]}</td>
                                                                        <td className="text-center">
                                                                            <div style={{ whiteSpace: 'nowrap' }}>
                                                                                <button className="btn btn-xs btn-warning" onClick={() => handleEdit && handleEdit(item.id)}>
                                                                                    <span className="fa fa-edit" /> Edit
                                                                                </button>
                                                                                <span style={{ display: 'inline-block', width: '8px' }}></span>
                                                                                <button className="btn btn-xs btn-danger" onClick={() =>handleRemove(item.id, item.email)}>
                                                                                    <i className="fa fa-trash" aria-label="Delete" />
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={5}>no results available</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>






                        </div>

                        {message}
                        {dialog}

                    </div>
                    {/* Loader */}
                    <div>
                        {isLoading && <div style={{ textAlign: 'center', marginTop: '20px' }}>Loading...</div>}
                        {!isLoading && Users.length === 0 && <div style={{ textAlign: 'center', marginTop: '20px' }}>No results available</div>}
                        {/* Place the observer div at the very end */}
                        <div ref={observerRef} style={{ height: '1px' }}></div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default Users;